<template>
  <div>
    <!-- <img class="white--text card-img" :src="src"> -->
    <v-toolbar card prominent class="title">
      <v-toolbar-title>{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="click()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
  </div>
</template>
<script>
export default {
  name: 'card-image',
  props: {
    src: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    onClick: {
      type: Function,
      default: _ => console.log('onClick')
    }
  },
  methods: {
    click () {
      this.onClick();
    }
  }
};
</script>
<style scoped>
.card-img {
  width: 100%;
  height: 50px;
  background: #f5f5f5;
}
.title {
  position: absolute;
  top: 0;
  font-size: 24pt !important;
}
</style>



// WEBPACK FOOTER //
// src/components/images/cardimage.vue